// extracted by mini-css-extract-plugin
export default {"compactModalWrap":"DeleteReasonModal_compactModalWrap__j2Y06","compactFormItem":"DeleteReasonModal_compactFormItem__qKK8Z","compactFooter":"DeleteReasonModal_compactFooter__d94P9"};